import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 16v-6a2 2 0 1 1 4 0v6","key":"svg-1"}],["path",{"d":"M10 13h4","key":"svg-2"}]]

const IconCircleLetterA = createReactComponent('outline', 'circle-letter-a', 'CircleLetterA', __iconNode);

export default IconCircleLetterA;